/**
 * Nährwert-Page: ?wein=HANDLE — Shopify cached Pages ignorieren Query-Strings.
 * Section per API mit korrektem Handle nachladen.
 */
(function () {
  const root = document.getElementById('wine-nutrition-dynamic');
  if (!root) return;

  function applyNutritionTitle(container) {
    const shopName =
      document.querySelector('meta[property="og:site_name"]')?.getAttribute('content') || '';
    const wineName = container.querySelector('.wine-nutrition-page__title')?.textContent?.trim();
    let base = 'Nährwertangaben';
    if (wineName) base += `: ${wineName}`;
    document.title = shopName ? `${base} – ${shopName}` : base;

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', base);
  }

  const handle = new URLSearchParams(window.location.search).get('wein');
  if (!handle) {
    applyNutritionTitle(root);
    return;
  }

  const serverHandle = (root.dataset.resolvedHandle || '').trim();
  if (serverHandle === handle.trim()) {
    applyNutritionTitle(root);
    return;
  }

  root.innerHTML =
    '<p class="wine-nutrition-page__loading page-width">Nährwertangaben werden geladen …</p>';

  const url = new URL(
    `/products/${encodeURIComponent(handle.trim())}`,
    window.location.origin
  );
  url.searchParams.set('view', 'naehrwerte-data');
  url.searchParams.set('_', String(Date.now()));

  fetch(url.toString())
    .then((response) => {
      if (!response.ok) throw new Error('product view fetch failed');
      return response.text();
    })
    .then((html) => {
      if (typeof html !== 'string' || html.length === 0) return;
      root.innerHTML = html.trim();
      applyNutritionTitle(root);
    })
    .catch(() => {});
})();
